import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getRequest } from '../../../request/request'
import { errors } from '../../../function/errors'
import { AppContext } from '../../../App'
import { Empty, Spin } from 'antd'
import { Title, WrapperData } from '../../../style/style'
import { Text } from '../../WrapperTextPage/style/WrapperTextPageStyle'
import { ContextType } from '../../../type/type'
import moment from 'moment'
import { DateNews } from '../style/NewsStyle'
import { formatDate } from '../../../function/formatDate'

const PageItemNew = () => {
  const { state } = useContext<ContextType>(AppContext)
  const { id } = useParams()
  const [data, setData] = useState<any>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [formatData, setFormatData] = useState<string>('DD.MM.YYYY')

  useEffect(() => {
    setLoading(true)

    setFormatData(formatDate(state.lang))

    getRequest(`/news/${id}/`)
      .then((res) => {
        setData(res?.data)
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
        errors(err)
      })
  }, [state.lang, id])

  return (
    <WrapperData className="br-12">
      {loading ? (
        <Spin spinning={loading} />
      ) : data ? (
        <>
          <DateNews className="date">{data?.date_creation && moment(data?.date_creation).format(formatData)}</DateNews>
          <Title className="title ">{data?.title}</Title>

          <Text className="box-text" dangerouslySetInnerHTML={{ __html: data?.text }} />
        </>
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
    </WrapperData>
  )
}

export default PageItemNew
